import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

export interface Report {
  id: string
  company: { id: number; name: string }
  created_at: string
  culture: string
  treatment: string
  file_reference: string
  name: string
  start_date: string
  end_date: string
  report_type: 'economy'
}

export const getEconomyReports = async (
  companyId: number,
  options?: AxiosRequestConfig,
) => {
  const { data } = await companiesApi.get<Report[]>(
    apiRoutes.getEconomyReports,
    {
      ...options,
      params: {
        idCompany: companyId,
      },
    },
  )

  return data
}
